export const defaultHeaderOptions = {
  enableSearch: true,
  enableAuthButtons: true,
};
